import {Howl} from 'howler'

let _audio
export function playAudio(soundPath, onPlayEnd = () => {}) {
  if(_audio && typeof _audio.stop === 'function') {
    _audio.stop()
  }

  const audio = new Howl({
    src: [soundPath],
    loop: false,
    volume: 0.75,
    onend: onPlayEnd
  })
  audio.play()
  _audio = audio
}

// 再生中のボイスを止める。
// iOSでマナーモード（サイレントスイッチON）かつイヤホン未接続の場合、ボイスは無音のまま
// 再生状態で進む。そこで動画を再生するとオーディオセッションが切り替わり、待機していた
// ボイスが動画と同時に鳴り出すため、動画モーダルを開くタイミングで明示的に止める。
export function stopAudio() {
  if(_audio && typeof _audio.stop === 'function') {
    _audio.stop()
  }
  _audio = undefined
  document.querySelectorAll('.sound-playing').forEach((el) => el.classList.remove('sound-playing'))
}
